import checkMovieByTimeRangeAndCinemas from "./checkMovieByTimeRangeAndCinemas"

const filterMoviesByTimeRangeAndCinema = (order, items, performances, startDate, endDate, cinemaIds = false, previewMode = false) => {
    const data = {
        relevant: [],
        current: [],
        future: [],
        noPerformances: [],
        hasPerformances: []
    }

    order.map(itemId => {
        const movie = items[itemId]
        const { inCinema, isCurrent, isFuture } = checkMovieByTimeRangeAndCinemas(movie, performances, startDate, endDate, cinemaIds)

        if((cinemaIds && inCinema) || !cinemaIds) {
            data.relevant.push(itemId)

            if(isCurrent && !previewMode) {
                data.current.push(itemId)
            } else if(isFuture && !previewMode) {
                data.future.push(itemId)
            } else if((!isCurrent && !isFuture) || previewMode) {
                if(movie.performances.length === 0) {
                    data.noPerformances.push(itemId)
                } else {
                    data.hasPerformances.push(itemId)
                }
            }
        }
    })
    
    return data
}

export default filterMoviesByTimeRangeAndCinema